// extracted by mini-css-extract-plugin
export var bullet = "customBullets-module--bullet--da67d";
export var bulletActive = "customBullets-module--bulletActive--0b4d8";
export var paginationContainer = "customBullets-module--paginationContainer--97913";